<template>
  <section v-if="contextData">
    <div class="container-wrap py-9 tablet:py-12">
      <h2 class="text-solution-h2 mb-2 tablet:line-clamp-2">
        {{ contextData.title }}
      </h2>
      <p
        class="mb-6 text-sm text-gray-600 tablet:mb-8 tablet:line-clamp-3 tablet:text-base desktop:mb-6 desktop:w-2/3"
      >
        {{ contextData.description }}
      </p>

      <ul :class="provideItemsClass">
        <li
          v-for="(item, index) in contextItems"
          :key="hash(item)"
          class="w-full border-b border-solid border-gray-400 pb-3 tablet:mb-3 tablet:border-none tablet:pb-0"
        >
          <SuiteListIconCard
            :item-data="item"
            :item-index="index"
            :inline-number="contextData.numberOfLine"
            :url-connector="urlConnector"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description?: string;
    thumbnail: string;
  }

  interface IListIconData {
    title: string;
    description?: string;
    numberOfLine: 2 | 3 | 4;
    items: IItem[];
  }

  interface IListIcon {
    component: 'list-icon';
    meta: {
      navigable?: string;
    };
    data: IListIconData;
  }

  type IProps = ISuiteProps<IListIcon>;

  const props = defineProps<IProps>();

  const contextData = computed((): IListIconData => props.suiteData.data);

  const contextItems = computed((): IItem[] => props.suiteData.data.items);

  const provideItemsClass = computed((): string => {
    switch (contextData.value.numberOfLine) {
      case 2:
        return 'column-221';
      case 3:
        return 'column-321';
      case 4:
        return 'column-421';
      default:
        return '';
    }
  });

  export type { IItem, IListIcon, IListIconData };
</script>
